///
/// EarthBrowser
///
/// Created by Matt Giger on 4/16/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useMemo } from "react"

const TRANSITION_PERIOD_DAYS = 14

export interface BetaStatus {
	isBeta: boolean
	daysRemaining: number | null
	betaEndDate: Date | null
	isTransitionPeriod: boolean
}

export function useBetaStatus(): BetaStatus {
	return useMemo(() => getBetaStatus(), [])
}

export function getBetaStatus(): BetaStatus {
	const betaMode = import.meta.env.VITE_BETA_MODE === "true"
	const endDateStr = import.meta.env.VITE_BETA_END_DATE

	if (!betaMode) {
		return { isBeta: false, daysRemaining: null, betaEndDate: null, isTransitionPeriod: false }
	}

	if (!endDateStr) {
		return { isBeta: true, daysRemaining: null, betaEndDate: null, isTransitionPeriod: false }
	}

	const betaEndDate = new Date(endDateStr)
	if (isNaN(betaEndDate.getTime())) {
		return { isBeta: true, daysRemaining: null, betaEndDate: null, isTransitionPeriod: false }
	}

	const now = new Date()
	const msRemaining = betaEndDate.getTime() - now.getTime()
	const daysRemaining = Math.ceil(msRemaining / (1000 * 60 * 60 * 24))

	if (daysRemaining <= 0) {
		return { isBeta: false, daysRemaining: 0, betaEndDate, isTransitionPeriod: false }
	}

	return {
		isBeta: true,
		daysRemaining,
		betaEndDate,
		isTransitionPeriod: daysRemaining <= TRANSITION_PERIOD_DAYS,
	}
}
